import { GAMES, CATEGORIES } from "@/lib/mockData";
import GameCard from "@/components/GameCard";
import { useState } from "react";

export default function Games() {
  const [cat, setCat] = useState("All");
  const list = cat === "All" ? GAMES : GAMES.filter(g => g.category === cat);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-blue-400 mb-2">Games</div>
        <h1 className="font-display text-4xl lg:text-5xl font-extrabold text-white">Tous vos jeux compétitifs, au même endroit.</h1>
      </div>
      <div className="flex flex-wrap gap-2 mb-8">
        {CATEGORIES.map(c => (
          <button key={c} data-testid={`cat-${c}`} onClick={() => setCat(c)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition border ${cat === c ? "bg-blue-600 border-blue-500 text-white" : "border-white/10 text-slate-300 hover:border-blue-500/50 hover:text-white"}`}>
            {c}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {list.map(g => <GameCard key={g.slug} game={g} />)}
      </div>
    </div>
  );
}
